import { render, staticRenderFns } from "./integralSpecifications.vue?vue&type=template&id=44518616"
import script from "./integralSpecifications.vue?vue&type=script&lang=js"
export * from "./integralSpecifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports